import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetListAPICommand} from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';
import {HealthTasks} from '../models/health-tasks.model';

export class GetHealthTasksCommand extends GetListAPICommand<HealthTasks> {
  constructor(apiService: ApiService, adapter: IAdapter<HealthTasks>) {
    super(apiService, adapter, `${environment.userApiUrl}/health-tasks`);
  }
}
